export class DateRange {
    constructor(begin, end) {
        this.begin = begin;
        this.end = end;
    }
    includes(date) {
        return date.isBetween(this.begin, this.end);
    }
    intersection(other) {
        const begin = this.begin.isAfter(other.begin) ? this.begin : other.begin;
        const end = this.end.isBefore(other.end) ? this.end : other.end;
        if (begin.isAfter(end)) {
            return null;
        }
        return new DateRange(begin, end);
    }
    toString() {
        return `${this.begin.toString} - ${this.end.toString}`;
    }
}
